"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

var _values = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/values"));

var _includes = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/includes"));

require("../../util/GlobalScript.js");

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames2 = _interopRequireDefault(require("classnames"));

var _HelpHint = _interopRequireDefault(require("../tooltips/HelpHint"));

var _EllipsisLoader = _interopRequireDefault(require("../general/EllipsisLoader"));

var _KeyboardUtils = require("../../util/KeyboardUtils");

var _underscore = _interopRequireDefault(require("underscore"));

/**
 * @enum {string}
 * @alias Button.buttonTypes
 */
var buttonTypes = {
  /** primary */
  PRIMARY: "primary",

  /** secondary */
  SECONDARY: "secondary",

  /** standard */
  STANDARD: "standard",

  /** success */
  SUCCESS: "success",

  /** cancel */
  CANCEL: "cancel",

  /** danger */
  DANGER: "danger",

  /** link */
  LINK: "link",

  /** button--icon-button */
  ICON: "button--icon-button"
};
/**
 * @class Button
 * @desc button component
 *
 * @param {Button.buttonTypes} [type]
 *      CSS class applied to html.
 * @param {boolean} active
 *     Active style of the button for when it's being used as a toggle.
 * @param {string} [className]
 *     Extra CSS class(s) applied to the top-level HTML container.
 * @param {string} [data-id="button"]
 *     Defines the "data-id" for top-level HTML container.
 * @param {boolean} [disabled=false]
 *     Button will not function when true.
 * @param {string} [disabledText]
 *     Text for the help hint will be rendered when the same button has disabled prop set to true.
 * @param {string} [helpHintPlacement="top"]
 *     How to position the helphint when disabledText is provided. Options can be found here:
 *     https://atomiks.github.io/tippyjs/v6/all-props/#placement
 * @param {string} [href]
 *     Pass in a string to give the button an href.
 * @param {string} [iconName]
 *     The name and CSS of the icon.
 * @param {boolean} [inline]
 *      When true, turns button into inline pill button.
 * @param {string} [label]
 *     Html name of the button
 * @param {boolean} loading
 *     While true, loading animation will be shown.
 * @param {function} [onClick]
 *     Click handler.
 *  @param {boolean} [noSpacing]
 *     Don't include the right margin.
 * @param {function} [onMouseDown]
 *     Mousedown handler..
 * @param {string} [target]
 *     Pass a string to give the button a target.
 * @param {string} text
 *     Text to display in the button when not loading.
 * @example
 *  <Button
 *      label="Button"
 *      type="Danger">
 *  </Button>
 */

var iconAliases = {
  "add": "plus",
  "remove": "minus",
  "prev": "left",
  "next": "right"
};

var iconAlias = function iconAlias(iconName) {
  return iconAliases[iconName] || iconName;
};

function BaseButton(_ref) {
  var _context;

  var active = _ref.active,
      children = _ref.children,
      className = _ref.className,
      dataId = _ref["data-id"],
      disabled = _ref.disabled,
      disabledText = _ref.disabledText,
      href = _ref.href,
      helpHintPlacement = _ref.helpHintPlacement,
      iconName = _ref.iconName,
      inline = _ref.inline,
      label = _ref.label,
      text = _ref.text,
      loading = _ref.loading,
      noSpacing = _ref.noSpacing,
      onClick = _ref.onClick,
      onMouseDown = _ref.onMouseDown,
      submit = _ref.submit,
      target = _ref.target,
      type = _ref.type;
  var hasLabel = label || text || children;
  var classes = (0, _classnames2.default)("button", className, (0, _defineProperty2.default)({
    "button--icon": iconName && hasLabel,
    "button--circle": iconName && !hasLabel,
    "button--no-spacing": noSpacing,
    inline: inline,
    loading: loading,
    disabled: disabled,
    "button--active": active,
    "ellipsis-loader-button": loading
  }, type, (0, _includes.default)(_context = (0, _values.default)(buttonTypes)).call(_context, type)));
  var TagName = href ? "a" : "button";

  var Tags = /*#__PURE__*/_react.default.createElement(TagName, {
    className: classes,
    "data-id": dataId,
    onClick: onClick,
    onMouseDown: onMouseDown,
    disabled: disabled,
    type: submit ? "submit" : "button",
    href: href,
    role: "button",
    target: target
  }, iconName && /*#__PURE__*/_react.default.createElement("span", {
    className: "icon-".concat(iconAlias(iconName), " button__icon")
  }), (label || text || children) && /*#__PURE__*/_react.default.createElement("span", {
    className: "button__text"
  }, label, text, children), /*#__PURE__*/_react.default.createElement(_EllipsisLoader.default, {
    loading: loading
  }));

  return disabled && disabledText ? /*#__PURE__*/_react.default.createElement(_HelpHint.default, {
    "data-id": "button_help-hint",
    hintText: disabledText,
    placement: helpHintPlacement
  }, Tags) : Tags;
}

var Button = (0, _KeyboardUtils.withFocusOutline)(BaseButton);
Button.displayName = "Button";
Button.propTypes = {
  active: _propTypes.default.bool,
  className: _propTypes.default.string,
  "data-id": _propTypes.default.string,
  disabled: _propTypes.default.bool,
  disabledText: _propTypes.default.string,
  helpHintPlacement: _propTypes.default.string,
  href: _propTypes.default.string,
  iconName: _propTypes.default.string,
  inline: _propTypes.default.bool,
  label: _propTypes.default.node,
  loading: _propTypes.default.bool,
  noSpacing: _propTypes.default.bool,
  onClick: _propTypes.default.func,
  onMouseDown: _propTypes.default.func,
  submit: _propTypes.default.bool,
  target: _propTypes.default.string,
  type: _propTypes.default.oneOf((0, _values.default)(buttonTypes))
};
Button.defaultProps = {
  active: false,
  "data-id": "button",
  disabled: false,
  helpHintPlacement: "top",
  loading: false,
  noSpacing: false,
  onClick: _underscore.default.noop,
  onMouseDown: _underscore.default.noop,
  submit: false
};
Button.buttonTypes = buttonTypes;
var _default = Button;
exports.default = _default;
module.exports = exports["default"];